import { useState, useEffect, useCallback } from 'react';
import {
  faEdit,
  faRotateRight,
  faIndianRupeeSign,
  faEye,
  faLink,
} from '@fortawesome/free-solid-svg-icons';
import JSONPretty from 'react-json-pretty';
import moment from 'moment';
import { withAppHOC } from '../../../hoc';
import PageHeading from '../../../components/PageHeader/PageHeader';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import NoData from '../../../components/NoData/NoData';
import StatusHighliter from '../../../components/StatusHighliter/StatusHighliter';
import {
  MessageBox,
  CustomButton,
  Label,
  Fieldset,
  TextInput,
  Button,
  Form,
  ResetButton,
  Dropdown,
  FormContainer,
  UpdateButton,
  CustomConfirmButton,
} from '../../../components/FormElements';
import { TableBuilder } from '../../../components/TableElements';
import Modal from '../../../components/Modal';
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader';
import {
  StyledFiltersContainer,
  StyledModalContainer,
  StyledBodyContainer,
  StyledHeading,
  StyledContent,
  StyledApiCallLogsContainer,
  StyledSpan,
  StyledLink,
} from '../../../components/Styled';
import Pagination from '../../../components/Pagination/Pagination';
import API from '../../../api';
import {
  ACCOUNT_TYPES,
  API_RESPONSE_TYPES,
  PERMISSION_TYPES,
} from '../../../constants';
import {
  getSearchParams,
  authData,
  formatCurrency,
  shouldRedirect,
  redirectToPageOne,
  downloadExportFile,
} from '../../../utils';
import FiltersButton from '../../../components/FiltersButton/FiltersButton';
import Accordination from '../../../components/Accordination/Accordination';
import { Grid, GridItem } from '../../../components/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty } from 'lodash';

const PANTransactionsTable = (props) => {
  const { accountType } = authData.get();
  const [paginationData, setPaginationData] = useState({
    pageNumber: getSearchParams('pageNumber') || 1,
    recordsPerPage: getSearchParams('recordsPerPage') || 100,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFiltering, setIsFiltering] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [logs, setLogs] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [rolesId, setRolesId] = useState('');
  const [accountsId, setAccountsId] = useState('');
  const [transactionsId, setTransactionsId] = useState('');
  const [orderid, setOrderid] = useState('');
  const [panMobileNumber, setPanMobileNumber] = useState('');
  const [panName, setPanName] = useState('');
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [transactionsStatus, setTransactionsStatus] = useState('');
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalTransactionsId, setModalTransactionsId] = useState('');
  const [pOrderId, setpOrderId] = useState('');
  const [ackNo, setAckNo] = useState('');
  const [panNumber, setPanNumber] = useState('');
  const [transactionStatus, setTransactionStatus] = useState('');

  const readApiLogs = (id) => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get(`/transactions/pan-logs/${id}`)
      .then((response) => {
        const { status, data } = response.data;
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setLogs(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const toggleApiLogs = (id) => {
    setModalType('API_LOGS');
    setShowModal(true);
    readApiLogs(id);
  };

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus('');
    setResponseMessage('');
  };

  const resetForm = () => {
    setRolesId('');
    setAccountsId('');
    setTransactionsId('');
    setOrderid('');
    setPanName('');
    setPanMobileNumber('');
    setStartDate(moment().format('YYYY-MM-DD'));
    setEndDate(moment().format('YYYY-MM-DD'));
    setTransactionsStatus('');
    readData(
      '',
      '',
      '',
      '',
      '',
      moment().format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD'),
      ''
    );
  };

  const resetModalForm = () => {
    setpOrderId('');
    setAckNo('');
    setPanNumber('');
    setTransactionStatus('');
  };

  const readAccounts = () => {
    API.get('/accounts-management/accounts').then((response) => {
      const { status, data } = response.data;
      if (status === API_RESPONSE_TYPES.SUCCESS) {
        setAccounts(data);
      }
    });
  };

  const readData = useCallback(
    (
      accountsId = '',
      transactionsId = '',
      ordersId = '',
      panName = '',
      panMobileNumber = '',
      startDate = '',
      endDate = '',
      transactionsStatus = ''
    ) => {
      setIsLoading(true);
      setResponseStatus('');
      setResponseMessage('');
      API.get(
        `/transactions/pan-transactions?faccountsId=${accountsId}&transactionsId=${transactionsId}&orderid=${ordersId}&panName=${panName}&panMobileNumber=${panMobileNumber}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}`
      )
        .then((response) => {
          const { status, data, pageInfo } = response.data;
          if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
            redirectToPageOne();
          } else {
            if (status === API_RESPONSE_TYPES.SUCCESS) {
              setTotalRecords(pageInfo.totalRecords);
            }
            setTransactions(data);
          }
        })
        .catch((error) => {
          setResponseStatus(API_RESPONSE_TYPES.FAILURE);
          setResponseMessage(error.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [paginationData]
  );

  // const onClickExport = () => {
  //   setIsLoading(true);
  //   setResponseStatus('');
  //   setResponseMessage('');
  //   API.get(
  //     `/transactions/pan-export?faccountsId=${accountsId}&transactionsId=${transactionsId}&orderid=${orderid}&panName=${panName}&panMobileNumber=${panMobileNumber}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}`
  //   )
  //     .then((response) => {
  //       const { status, message } = response.data;
  //       if (status === API_RESPONSE_TYPES.FAILURE) {
  //         setResponseStatus(status);
  //         setResponseMessage(message);
  //       } else {
  //         setResponseStatus(status);
  //         setResponseMessage(message);
  //         setTimeout(() => {
  //           setResponseStatus('');
  //           setResponseMessage('');
  //         }, 3000);
  //       }
  //     })
  //     .catch((error) => {
  //       setResponseStatus(API_RESPONSE_TYPES.FAILURE);
  //       setResponseMessage(error.message);
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };

  const onClickExport = () => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');

    downloadExportFile({
      url: `/transactions/pan-export?faccountsId=${accountsId || ''}&transactionsId=${transactionsId || ''}&orderid=${orderid || ''}&panName=${panName || ''}&panMobileNumber=${panMobileNumber || ''}&startDate=${startDate || ''}&endDate=${endDate || ''}&transactionsStatus=${transactionsStatus || ''}&pageNumber=${paginationData.pageNumber || 1}&recordsPerPage=${paginationData.recordsPerPage || 10}`,
      fileName: 'pan_transactions.csv',
      setIsLoading,
      setResponseStatus,
      setResponseMessage,
    });
  };
  const updateTransaction = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.put(
      `/transactions/pan-update/${modalTransactionsId}?faccountsId=${accountsId}&transactionsId=${transactionsId}&orderid=${orderid}&panName=${panName}&panMobileNumber=${panMobileNumber}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}`,
      {
        pOrderId,
        ackNo,
        transactionStatus,
        panNumber,
      }
    )
      .then((response) => {
        const { status, message, data, pageInfo } = response.data;
        if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
          redirectToPageOne();
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
          if (status === API_RESPONSE_TYPES.SUCCESS) {
            setTransactions(data);
            setTotalRecords(pageInfo.totalRecords);
            setTimeout(() => {
              setShowModal(false);
              setModalTransactionsId('');
              resetResponseData();
            }, 3000);
          }
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const refundTransaction = (id) => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.put(
      `/transactions/refund-pan-transaction/${id}?faccountsId=${accountsId}&transactionsId=${transactionsId}&orderid=${orderid}&panName=${panName}&panMobileNumber=${panMobileNumber}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}`
    )
      .then((response) => {
        const { status, message, data, pageInfo } = response.data;
        if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
          redirectToPageOne();
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
          if (status === API_RESPONSE_TYPES.SUCCESS) {
            setTransactions(data);
            setTotalRecords(pageInfo.totalRecords);
          }
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
        setTimeout(() => {
          resetResponseData();
        }, 3000);
      });
  };

  const reloadTransactionStatus = (id) => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get(
      `/transactions/pan-transaction-status/${id}?faccountsId=${accountsId}&transactionsId=${transactionsId}&orderid=${orderid}&panName=${panName}&panMobileNumber=${panMobileNumber}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}`
    )
      .then((response) => {
        const { status, message, data, pageInfo } = response.data;
        if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
          redirectToPageOne();
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
          if (status === API_RESPONSE_TYPES.SUCCESS) {
            setTransactions(data);
            setTotalRecords(pageInfo.totalRecords);
          }
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
        setTimeout(() => {
          resetResponseData();
        }, 3000);
      });
  };

  const reloadPanStatus = (id) => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get(
      `/transactions/pan-status/${id}?faccountsId=${accountsId}&transactionsId=${transactionsId}&orderid=${orderid}&panName=${panName}&panMobileNumber=${panMobileNumber}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}`
    )
      .then((response) => {
        const { status, message, data, pageInfo } = response.data;
        if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
          redirectToPageOne();
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
          if (status === API_RESPONSE_TYPES.SUCCESS) {
            setTransactions(data);
            setTotalRecords(pageInfo.totalRecords);
          }
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
        setTimeout(() => {
          resetResponseData();
        }, 3000);
      });
  };

  const reloadData = () => {
    readData(
      accountsId,
      transactionsId,
      orderid,
      panName,
      panMobileNumber,
      startDate,
      endDate,
      transactionsStatus
    );
  };

  const filterData = (e) => {
    e.preventDefault();
    setIsFiltering(true);
  };

  useEffect(() => {
    if (isFiltering) {
      setPaginationData((paginationData) => ({
        pageNumber: 1,
        recordsPerPage: paginationData.recordsPerPage,
      }));
      setIsFiltering((isFiltering) => !isFiltering);
    }
  }, [isFiltering]);

  useEffect(() => {
    if (
      ![ACCOUNT_TYPES.RETAILERS, ACCOUNT_TYPES.API_USERS].includes(accountType)
    ) {
      readAccounts();
    }
  }, [accountType]);

  useEffect(() => {
    if (!isFiltering) {
      readData(
        accountsId,
        transactionsId,
        orderid,
        panName,
        panMobileNumber,
        startDate,
        endDate,
        transactionsStatus
      );
    }
  }, [paginationData, readData, accountType]);

  const {
    accountsPermissions,
    appData: { appLogo, appName },
  } = props;

  const canExport =
    accountsPermissions.includes(PERMISSION_TYPES.EXPORT) || false;
  const canUpdate =
    accountsPermissions.includes(PERMISSION_TYPES.UPDATE) || false;
  const canRefund =
    accountsPermissions.includes(PERMISSION_TYPES.REFUND) || false;
  const canStatusCheck =
    accountsPermissions.includes(PERMISSION_TYPES.STATUS_CHECK) || false;
  const canTrack =
    accountsPermissions.includes(PERMISSION_TYPES.TRACK) || false;

  const rolesOptions = [{ title: '-- SELECT ROLE --', value: '' }];
  if (accountType === ACCOUNT_TYPES.MASTER_DISTRIBUTORS) {
    [
      {
        id: 3,
        roleName: 'Distributors',
      },
      {
        id: 4,
        roleName: 'Retailers',
      },
    ].forEach(({ id, roleName }) =>
      rolesOptions.push({
        title: roleName,
        value: id,
      })
    );
  } else if (accountType === ACCOUNT_TYPES.DISTRIBUTORS) {
    [
      {
        id: 4,
        roleName: 'Retailers',
      },
    ].forEach(({ id, roleName }) =>
      rolesOptions.push({
        title: roleName,
        value: id,
      })
    );
  } else {
    [
      {
        id: 2,
        roleName: 'Master Distributors',
      },
      {
        id: 3,
        roleName: 'Distributors',
      },
      {
        id: 4,
        roleName: 'Retailers',
      },
      {
        id: 5,
        roleName: 'Api Users',
      },
    ].forEach(({ id, roleName }) =>
      rolesOptions.push({
        title: roleName,
        value: id,
      })
    );
  }

  const accountsOptions = [{ title: '-- SELECT ACCOUNT --', value: '' }];
  accounts
    .filter((account) => account?.isDeleted === 'No')
    .filter(({ accountsRolesId }) =>
      rolesId !== ''
        ? accountsRolesId === rolesId
        : [2, 3, 4, 5].includes(accountsRolesId)
    )
    .forEach(({ id, firstName, lastName, mobileNumber, roleName }) =>
      accountsOptions.push({
        title: `${firstName} ${lastName}`,
        value: id,
        subTitle: `${mobileNumber}, ${roleName}`,
      })
    );

  const [showFilters, setShowFilters] = useState(false);
  const onClickShowFilters = () => {
    setShowFilters((showFilters) => !showFilters);
  };

  return (
    <>
      <PageHeading
        {...props}
        reloadData={reloadData}
        showExport={canExport}
        onClickExport={onClickExport}
      />
      <FiltersButton onClick={onClickShowFilters} value={showFilters} />
      <StyledFiltersContainer className={showFilters ? 'show' : ''}>
        <Form method="POST" action="#" onSubmit={filterData}>
          {![ACCOUNT_TYPES.RETAILERS, ACCOUNT_TYPES.API_USERS].includes(
            accountType
          ) && (
              <>
                <Fieldset>
                  <Label>Role</Label>
                  <Dropdown
                    style={{ border: '1px solid #cacaca' }}
                    placeholder="Role"
                    value={rolesId}
                    onChange={(value) => {
                      setAccountsId('');
                      setRolesId(value);
                    }}
                    options={rolesOptions}
                    disabled={isLoading}
                  />
                </Fieldset>
                <Fieldset>
                  <Label>Account</Label>
                  <Dropdown
                    style={{ border: '1px solid #cacaca' }}
                    placeholder="Account"
                    value={accountsId}
                    onChange={setAccountsId}
                    options={accountsOptions}
                    disabled={isLoading}
                  />
                </Fieldset>
              </>
            )}
          <Fieldset>
            <Label>Transaction ID</Label>
            <TextInput
              value={transactionsId}
              onChange={setTransactionsId}
              placeholder="Transactions ID"
              maxLength={100}
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Label>Order ID</Label>
            <TextInput
              value={orderid}
              onChange={setOrderid}
              placeholder="Transactions ID"
              maxLength={100}
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Label>PAN Applicant Name</Label>
            <TextInput
              value={panName}
              onChange={setPanName}
              placeholder="PAN Applicant Name"
              maxLength={100}
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Label>PAN Applicant Mobile</Label>
            <TextInput
              value={panMobileNumber}
              onChange={setPanMobileNumber}
              placeholder="PAN Applicant Mobile"
              maxLength={100}
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Label>Transaction Status</Label>
            <Dropdown
              style={{ border: '1px solid #cacaca' }}
              placeholder="Transaction Status"
              value={transactionsStatus}
              onChange={setTransactionsStatus}
              options={[
                {
                  title: '-- SELECT STATUS --',
                  value: '',
                },
                {
                  title: 'Success',
                  value: 'Success',
                },
                {
                  title: 'Failure',
                  value: 'Failure',
                },
                {
                  title: 'Pending',
                  value: 'Pending',
                },
              ]}
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>Start Date</Label>
            <TextInput
              type="date"
              value={startDate}
              onChange={setStartDate}
              placeholder="Start Date"
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Label>End Date</Label>
            <TextInput
              type="date"
              value={endDate}
              onChange={setEndDate}
              placeholder="End Date"
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Button disabled={isLoading === true} type="submit">
              Filter
            </Button>
            <ResetButton
              disabled={isLoading === true}
              type="button"
              onClick={resetForm}
            >
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
      </StyledFiltersContainer>
      <LoadingSpinner
        isLoading={
          !showModal &&
          responseStatus === '' &&
          transactions?.length === 0 &&
          isLoading
        }
      />
      <NoData
        status={
          responseStatus !== API_RESPONSE_TYPES.FAILURE &&
          !isLoading &&
          transactions?.length === 0
        }
        message={`No transactions found`}
      />
      {!showModal && (
        <MessageBox status={responseStatus} message={responseMessage} />
      )}
      {transactions?.length > 0 && (
        <>
          {[
            ACCOUNT_TYPES.MASTER_DISTRIBUTORS,
            ACCOUNT_TYPES.DISTRIBUTORS,
            ACCOUNT_TYPES.RETAILERS,
            ACCOUNT_TYPES.API_USERS,
          ].includes(accountType) ? (
            <TableBuilder
              isLoading={!showModal && transactions?.length !== 0 && isLoading}
              tableHeadings={[
                {
                  title: '',
                  dataSelector: 'id',
                  sticky: true,
                  canSort: false,
                  width: '100px',
                  CellRenderer: (value, item) => (
                    <>
                      {item.transactionStatus === 'Pending' && (
                        <StyledLink
                          to={item?.redirectUrl}
                          title={'Pan Application Form'}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </StyledLink>
                      )}
                    </>
                  ),
                },
                {
                  title: 'Transaction ID',
                  dataSelector: 'id',
                  dataType: 'number',
                  CellRenderer: (value, item) => (
                    <>
                      {value}
                      {item.orderId && (
                        <StyledSpan>Order ID : {item.orderId}</StyledSpan>
                      )}
                    </>
                  ),
                },
                {
                  title: 'Date & Time',
                  dataSelector: 'createdOn',
                  dataType: 'date',
                  CellRenderer: (value, item) => {
                    const splitedVal = value.split(' ');
                    return (
                      <>
                        <span style={{ display: 'block', margin: '10px 0px' }}>
                          {splitedVal[0]}
                        </span>
                        <span style={{ display: 'block', margin: '10px 0px' }}>
                          {splitedVal[1]} {splitedVal[2]}
                        </span>
                      </>
                    );
                  },
                },
                {
                  title: 'Amount',
                  dataSelector: 'amount',
                  dataType: 'number',
                  CellRenderer: (value, item) => (
                    <>
                      Amount : {formatCurrency(value)}
                      <StyledSpan>
                        Commission :{formatCurrency(item.commission)}
                      </StyledSpan>
                    </>
                  ),
                },
                {
                  title: 'PAN Application Details',
                  dataSelector: 'panName',
                  dataType: 'string',
                  CellRenderer: (value, item) => (
                    <>
                      {value} ( {item.panGender} )
                      <StyledSpan>Email : {item.panEmail}</StyledSpan>
                      <StyledSpan>Mobile : {item.panMobileNumber}</StyledSpan>
                      <StyledSpan>Mode : {item.panApplicationMode}</StyledSpan>
                      <StyledSpan>Type : {item.panApplicationType}</StyledSpan>
                      <StyledSpan>
                        Physical Card Required : {item.panPhysicalCardRequired}
                      </StyledSpan>
                    </>
                  ),
                },
                {
                  title: 'PAN Number',
                  dataSelector: 'pan',
                  dataType: 'string',
                  CellRenderer: (value) => value ?? 'N/A',
                },
                {
                  title: 'Transaction Status',
                  dataSelector: 'transactionStatus',
                  dataType: 'string',
                  align: 'center',
                  CellRenderer: (value) =>
                    value && (
                      <StatusHighliter
                        className={
                          value === 'Success'
                            ? 'green'
                            : value === 'Failure'
                              ? 'red'
                              : value === 'Pending'
                                ? 'yellow'
                                : 'blue'
                        }
                      >
                        {value}
                      </StatusHighliter>
                    ),
                },
                {
                  title: 'PAN Status',
                  dataSelector: 'panStatus',
                  dataType: 'string',
                },
                {
                  title: 'Refund Status',
                  dataSelector: 'refundStatus',
                  dataType: 'string',
                },
                {
                  title: 'Refunded On',
                  dataSelector: 'refundedTimeStamp',
                  dataType: 'string',
                  CellRenderer: (value) => (value ? value : 'N/A'),
                },
              ]}
              tableData={transactions}
            />
          ) : (
            <TableBuilder
              isLoading={!showModal && transactions?.length !== 0 && isLoading}
              tableHeadings={[
                {
                  title: '',
                  dataSelector: 'id',
                  sticky: true,
                  canSort: false,
                  width: '100px',
                  CellRenderer: (value, item) => (
                    <>
                      {canTrack && (
                        <CustomButton
                          icon={faEye}
                          onClick={() => toggleApiLogs(value)}
                          style={{ color: 'orange' }}
                        />
                      )}
                      {canUpdate && item.transactionStatus !== 'Failure' && (
                        <CustomButton
                          icon={faEdit}
                          onClick={() => {
                            setModalTransactionsId(value);
                            setpOrderId(item.pOrderId);
                            setAckNo(item.ackNo);
                            setTransactionStatus(item.transactionStatus);
                            setPanNumber(item.pan);
                            setShowModal(true);
                          }}
                          style={{ color: '#0095ff' }}
                        />
                      )}
                      {canStatusCheck &&
                        item.transactionStatus !== 'Failure' && (
                          <CustomButton
                            icon={faRotateRight}
                            onClick={() => reloadTransactionStatus(value)}
                            style={{ color: '#333f7a' }}
                          />
                        )}
                      {canStatusCheck &&
                        !isEmpty(item.ackNo) &&
                        item.transactionStatus !== 'Failure' && (
                          <CustomButton
                            icon={faRotateRight}
                            onClick={() => reloadPanStatus(value)}
                            style={{ color: '#333f7a' }}
                          />
                        )}
                      {canRefund &&
                        (item.transactionStatus === 'Success' ||
                          item.transactionStatus === 'Pending') && (
                          <CustomConfirmButton
                            icon={faIndianRupeeSign}
                            title="Refund"
                            message="Are you sure, you want to refund this transaction ?"
                            proceedButtonText="Refund"
                            cancelButtonText="Cancel"
                            onClick={() => refundTransaction(value)}
                            color="forestgreen"
                            hoverColor="#006200"
                          />
                        )}
                      {item.transactionStatus === 'Pending' && (
                        <StyledLink
                          to={item?.redirectUrl}
                          title={'Pan Application Form'}
                        >
                          <FontAwesomeIcon icon={faLink} />
                        </StyledLink>
                      )}
                    </>
                  ),
                },
                {
                  title: 'Transaction ID',
                  dataSelector: 'id',
                  dataType: 'number',
                  CellRenderer: (value, item) => (
                    <>
                      {value}
                      {item.orderId && (
                        <StyledSpan>Order ID : {item.orderId}</StyledSpan>
                      )}
                      {item.pOrderId && (
                        <StyledSpan>API Order ID : {item.pOrderId}</StyledSpan>
                      )}
                      {item.ackNo && (
                        <StyledSpan>Ack No : {item.ackNo}</StyledSpan>
                      )}
                    </>
                  ),
                },
                {
                  title: 'Date & Time',
                  dataSelector: 'createdOn',
                  dataType: 'date',
                  CellRenderer: (value, item) => {
                    const splitedVal = value.split(' ');
                    return (
                      <>
                        <span style={{ display: 'block', margin: '10px 0px' }}>
                          {splitedVal[0]}
                        </span>
                        <span style={{ display: 'block', margin: '10px 0px' }}>
                          {splitedVal[1]} {splitedVal[2]}
                        </span>
                      </>
                    );
                  },
                },
                {
                  title: 'Account Details',
                  dataSelector: 'accountsName',
                  dataType: 'string',
                  CellRenderer: (value, item) => (
                    <>
                      {value}
                      <StyledSpan>{item.accountsMobileNumber}</StyledSpan>
                      <StyledSpan>{item.accountsRoleName}</StyledSpan>
                    </>
                  ),
                },
                {
                  title: 'Amount',
                  dataSelector: 'amount',
                  dataType: 'number',
                  CellRenderer: (value, item) => (
                    <>
                      Amount : {formatCurrency(value)}
                      <StyledSpan>
                        Commission :{formatCurrency(item.commission)}
                      </StyledSpan>
                    </>
                  ),
                },
                {
                  title: 'PAN Application Details',
                  dataSelector: 'panName',
                  dataType: 'string',
                  CellRenderer: (value, item) => (
                    <>
                      {value} ( {item.panGender} )
                      <StyledSpan>Email : {item.panEmail}</StyledSpan>
                      <StyledSpan>Mobile : {item.panMobileNumber}</StyledSpan>
                      <StyledSpan>Mode : {item.panApplicationMode}</StyledSpan>
                      <StyledSpan>Type : {item.panApplicationType}</StyledSpan>
                      <StyledSpan>
                        Physical Card Required : {item.panPhysicalCardRequired}
                      </StyledSpan>
                    </>
                  ),
                },
                {
                  title: 'PAN Number',
                  dataSelector: 'pan',
                  dataType: 'string',
                  CellRenderer: (value) => value ?? 'N/A',
                },
                {
                  title: 'Transaction Status',
                  dataSelector: 'transactionStatus',
                  dataType: 'string',
                  align: 'center',
                  CellRenderer: (value) =>
                    value && (
                      <StatusHighliter
                        className={
                          value === 'Success'
                            ? 'green'
                            : value === 'Failure'
                              ? 'red'
                              : value === 'Pending'
                                ? 'yellow'
                                : 'blue'
                        }
                      >
                        {value}
                      </StatusHighliter>
                    ),
                },
                {
                  title: 'PAN Status',
                  dataSelector: 'panStatus',
                  dataType: 'string',
                },
                {
                  title: 'Refund Status',
                  dataSelector: 'refundStatus',
                  dataType: 'string',
                },
                {
                  title: 'Refunded On',
                  dataSelector: 'refundedTimeStamp',
                  dataType: 'string',
                  CellRenderer: (value) => (value ? value : 'N/A'),
                },
                {
                  title: 'Supervisor 1',
                  dataSelector: 'supervisor1Commission',
                  dataType: 'number',
                  CellRenderer: (value, item) => (
                    <>
                      Commission : {formatCurrency(value)}
                      {item.supervisor1Name &&
                        item.supervisor1Name !== 'null' && (
                          <StyledSpan>{item.supervisor1Name}</StyledSpan>
                        )}
                    </>
                  ),
                },
                {
                  title: 'Supervisor 2',
                  dataSelector: 'supervisor2Commission',
                  dataType: 'number',
                  CellRenderer: (value, item) => (
                    <>
                      Commission : {formatCurrency(value)}
                      {item.supervisor2Name &&
                        item.supervisor2Name !== 'null' && (
                          <StyledSpan>{item.supervisor2Name}</StyledSpan>
                        )}
                    </>
                  ),
                },
              ]}
              tableData={transactions}
            />
          )}
          <Pagination
            totalRecords={totalRecords}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
          <Modal
            modalStatus={showModal}
            setModalStatus={() => {
              resetResponseData();
              resetModalForm();
              setShowModal(false);
              setModalType('');
              setLogs([]);
            }}
            hideCloseButton
          >
            <StyledModalContainer
              width={modalType === 'API_LOGS' ? `1200px` : `500px`}
            >
              <h3>
                {modalType === 'API_LOGS'
                  ? `API Call Logs`
                  : `Update Transaction`}
              </h3>
              {modalType === 'API_LOGS' ? (
                <StyledApiCallLogsContainer>
                  <LoadingSpinner
                    isLoading={
                      responseStatus === '' && logs?.length === 0 && isLoading
                    }
                  />
                  <NoData
                    status={
                      responseStatus !== API_RESPONSE_TYPES.FAILURE &&
                      !isLoading &&
                      logs?.length === 0
                    }
                    message={`No api logs found`}
                  />
                  <MessageBox
                    status={responseStatus}
                    message={responseMessage}
                  />
                  {logs?.length > 0 &&
                    logs.map(
                      (
                        {
                          createdOn,
                          type: processType,
                          requestUrl: request,
                          requestBody,
                          requestHeaders,
                          response,
                          responseType,
                          updatedOn: responseTime,
                        },
                        index
                      ) => (
                        <Accordination
                          key={index}
                          header={`${processType}`}
                          autoExpanded={true}
                        >
                          <Grid columns={'calc(50% - 10px) calc(50% - 10px)'}>
                            <GridItem>
                              <StyledBodyContainer>
                                <StyledHeading>
                                  API Request {createdOn && `( ${createdOn} )`}
                                </StyledHeading>
                                <StyledContent>{request}</StyledContent>
                              </StyledBodyContainer>
                              {requestBody && (
                                <StyledBodyContainer>
                                  <StyledHeading>
                                    API Request Body
                                  </StyledHeading>
                                  <StyledContent>{requestBody}</StyledContent>
                                </StyledBodyContainer>
                              )}
                              {requestHeaders && (
                                <StyledBodyContainer>
                                  <StyledHeading>
                                    API Request Headers
                                  </StyledHeading>
                                  <StyledContent>
                                    {requestHeaders}
                                  </StyledContent>
                                </StyledBodyContainer>
                              )}
                            </GridItem>
                            <GridItem>
                              <StyledBodyContainer>
                                <StyledHeading>
                                  API Response{' '}
                                  {responseTime && `( ${responseTime} )`}
                                </StyledHeading>
                                <StyledContent>
                                  {responseType === 'XML' ? (
                                    <code>{response}</code>
                                  ) : (
                                    <JSONPretty
                                      id="json-pretty"
                                      data={response}
                                    ></JSONPretty>
                                  )}
                                </StyledContent>
                              </StyledBodyContainer>
                            </GridItem>
                          </Grid>
                        </Accordination>
                      )
                    )}
                </StyledApiCallLogsContainer>
              ) : (
                <FormContainer>
                  <Form method="POST" action="#" onSubmit={updateTransaction}>
                    <Fieldset>
                      <Label>API Order ID</Label>
                      <TextInput
                        value={pOrderId}
                        onChange={setpOrderId}
                        placeholder="Please enter api order id"
                        disabled={isLoading === true}
                      />
                    </Fieldset>
                    <Fieldset>
                      <Label>Ack No</Label>
                      <TextInput
                        value={ackNo}
                        onChange={setAckNo}
                        placeholder="Please enter ack number"
                        disabled={isLoading === true}
                      />
                    </Fieldset>
                    <Fieldset>
                      <Label required>Transaction Status</Label>
                      <Dropdown
                        placeholder="Please select transaction status"
                        value={transactionStatus}
                        onChange={setTransactionStatus}
                        options={[
                          {
                            title: '-- SELECT STATUS --',
                            value: '',
                          },
                          {
                            title: 'Success',
                            value: 'Success',
                          },
                          {
                            title: 'Failure',
                            value: 'Failure',
                          },
                          {
                            title: 'Pending',
                            value: 'Pending',
                          },
                        ]}
                        disabled={isLoading}
                      />
                    </Fieldset>
                    <Fieldset>
                      <Label>PAN Number</Label>
                      <TextInput
                        value={panNumber}
                        onChange={setPanNumber}
                        placeholder="Please enter pan number"
                        disabled={isLoading === true}
                      />
                    </Fieldset>
                    {showModal && responseStatus !== '' && (
                      <Fieldset>
                        <MessageBox
                          status={responseStatus}
                          message={responseMessage}
                        />
                      </Fieldset>
                    )}
                    <Fieldset>
                      <UpdateButton
                        disabled={isLoading === true}
                        type="submit"
                        style={{ width: 'auto' }}
                      >
                        Update
                      </UpdateButton>
                      <ResetButton
                        disabled={isLoading === true}
                        type="button"
                        onClick={resetModalForm}
                      >
                        Reset
                      </ResetButton>
                    </Fieldset>
                    <OverlayLoader showLoader={showModal && isLoading} />
                  </Form>
                </FormContainer>
              )}
            </StyledModalContainer>
          </Modal>
        </>
      )}
    </>
  );
};

export default withAppHOC(PANTransactionsTable);
